import { type SearchMultipleSelectionProps, FormSearchSelection } from '@shared/components';

export type BaseSearchSelectionProps = Pick<SearchMultipleSelectionProps, 'options' | 'label'> & {
  name: string;
  value: { label: string; value: string } | undefined;
};

export default function BaseSearchSelection(props: Readonly<BaseSearchSelectionProps>) {
  const { name, value, options, label } = props;

  return (
    <FormSearchSelection
      name={name}
      options={options}
      label={label}
      defaultValue={value}
      sx={{ width: '100%' }}
      slotProps={{
        input: { placeholder: value === undefined ? 'แสดงทั้งหมด' : '' },
      }}
    />
  );
}
